const BASE = "/activite_operations";

export const ACTIVITY_OPERATIONS_ENDPOINTS = {
  list: BASE,
  balance: `${BASE}/balance`,
  modules: `${BASE}/modules`,
  references: `${BASE}/references`,
  genres: `${BASE}/genres`,
  familles: `${BASE}/familles`,
  exportXlsx: `${BASE}/export_xlsx`,
  // Manual avoir/facture creation = Core::Invoice (owns the AO + optional SLE)
  createAdjustment: "/invoices",
  invoice: (id: string) => `/invoices/${id}`,
  // Onglet Comptabilité de la facture/avoir (règlement employé-centré)
  invoiceAccountingLines: (id: string) => `/invoices/${id}/accounting_lines`,
  invoiceSettleWithPayment: (id: string) => `/invoices/${id}/settle_with_payment`,
  invoiceCompensate: (id: string) => `/invoices/${id}/compensate`,
  // Rules of a policy (for the create dialog rule picker)
  policyRules: (policyId: string) => `/subsidy/policies/${policyId}/rules`,
} as const;
